function DeleteException (error: any) {
  return error;
}

export default DeleteException;
